import {BookingSearchStrategyBase} from "../booking-search-strategy-base";
import {IBookingSearchCommonPersistedFields, IBookingSearchCommonFields} from "./booking-search-common-fields.interface";
import {FormFields} from "../../../../models/forms/form-field.interface";
import {Station} from "../../../stations/station.service.interface";
import {
    IBookingSearchFilters,
    IBookingSearchPagination
} from "../../../airline-webapi/requests/booking-search.requests";

export abstract class StandardBookingSearchStrategy<TFields extends IBookingSearchCommonFields, TPersistedFields extends IBookingSearchCommonPersistedFields>
        extends BookingSearchStrategyBase<TFields, TPersistedFields> {

    protected _createCommonFields(persistedFields: TPersistedFields | null): FormFields<IBookingSearchCommonFields> {
        return {
            flightNumber: this._createField<string>({
                fieldName: () => this.services.language.translate('Flight number'),
                defaultValue: persistedFields?.flightNumber ?? "",
                isRequired: false
            }),
            origin: this._createField<Station>({
                fieldName: () => this.services.language.translate('Origin'),
                defaultValue: this.services.stations.tryGetStation(persistedFields?.origin),
                isRequired: false
            }),
            destination: this._createField<Station>({
                fieldName: () => this.services.language.translate('Destination'),
                defaultValue: this.services.stations.tryGetStation(persistedFields?.destination),
                isRequired: false
            }),
            departureDate: this._createField<Date>({
                fieldName: () => this.services.language.translate('Departure date'),
                defaultValue: this.services.time.tryConvertToDate(persistedFields?.departureDate),
                isRequired: false
            })
        }
    }

    protected _createCommonFilters(pagination: IBookingSearchPagination): IBookingSearchFilters {
        const filters: IBookingSearchFilters = {
            pagination: pagination
        }

        if(this.fields.origin.value) {
            filters.origin = this.fields.origin.value.stationCode;
        }

        if(this.fields.destination.value) {
            filters.destination = this.fields.destination.value.stationCode;
        }

        if(this.fields.flightNumber.value) {
            filters.flightNumber = this.fields.flightNumber.value;
        }

        if(this.fields.departureDate.value) {
            filters.departureDate = this._formatDateYYYY_MM_DD(this.fields.departureDate.value);
        }

        return filters;
    }

    protected _collectCommonFieldsValuesForStorage(): IBookingSearchCommonPersistedFields {
        return {
            flightNumber: this.fields.flightNumber.value,
            origin: this.fields.origin.value?.stationCode ?? null,
            destination: this.fields.destination.value?.stationCode ?? null,
            departureDate:  this._formatDateYYYY_MM_DD(this.fields.departureDate.value)
        }
    }

}